
import Vue from 'vue'

const RESPONSE = {
	id: 0,
	conceptId: 2,
}

export default (conceptPhoto) => {

	return new Promise((resolve, reject) =>
		resolve({
			...RESPONSE,
			...conceptPhoto,
		}))
}


// WEBPACK FOOTER //
// ./src/services/workPlan/sendEvidencePhoto.js